import { render } from "./index-az.vue?vue&type=template&id=2a57d156&scoped=true&ts=true"
import script from "./index-az.vue?vue&type=script&lang=ts"
export * from "./index-az.vue?vue&type=script&lang=ts"

import "./index-az.vue?vue&type=style&index=0&id=2a57d156&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a57d156"]])

export default __exports__